import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheGrandEntrance from "./sections/TheGrandEntrance";
import CurationByEra from "./sections/CurationByEra";
import TimelessTreasures from "./sections/TimelessTreasures";
import OurNoblePursuit from "./sections/OurNoblePursuit";
import JoinTheInnerCircle from "./sections/JoinTheInnerCircle";
import ArtworkDetailsForm from "./sections/ArtworkDetailsForm";
import ShippingDetails from "./sections/ShippingDetails";
import HeritageFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheGrandEntrance />
      <CurationByEra />
      <TimelessTreasures />
      <OurNoblePursuit />
      <JoinTheInnerCircle />
      <ArtworkDetailsForm />
      <ShippingDetails />
      <HeritageFooter />
    </div>;
}